import React, { ReactNode } from 'react';
import { IWprControlProps } from '../props/IWprControlProps';
import { WprBaseControlComponent } from './WprBaseControlComponent';
import { WprControlVisibility } from '../props/IWprControlState';

/**
 * SPANコントロールプロパティ情報
 */
interface IWprSpanProps extends IWprControlProps {
	converter?: string;			// コンバータ
}

/**
 * SPANコントロール
 */
export class WprSpan extends WprBaseControlComponent<IWprSpanProps, HTMLSpanElement> {
	// プロパティ  ---------------------------------------------------------------
	/** 編集フラグ */
	public get isEdit(): boolean	{ return false; 	}
	// --------------------------------------------------------------------------

	// コンストラクタ  -----------------------------------------------------------
	constructor(props: IWprSpanProps){
		super(props);
	}
	// --------------------------------------------------------------------------

	// override メソッド  --------------------------------------------------------
	/**
	 * 値取得
	 * @returns 値
	 */
	protected getValue(): any {
		return undefined;
	}

	/**
	 * 描画
	 */
	public onRender(): ReactNode {
		if (this.state.visibility === WprControlVisibility.COLLAPSED)
			return <></>;
		const props = this.getProps();
		const {name, view, className, converter, children, ...other} = this.props;
		const state = this.getState(['style', 'disabled']);
		let span = null;
		if (this.state.visibility === WprControlVisibility.VISIBLE) {
			if (this.hasBr() === false)
				span = <span {...props} {...state} {...other}>{`${this.getStateValue()}`}</span>;
			else
				span = <span {...props} {...state} {...other}>{this.getBrContent()}</span>;
		}
		else {
			span = <span hidden {...props} {...state} {...other}>{`${this.getStateValue()}`}</span>;
		}
		return (
			<>
				{span}
			</>
		);
	}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * ステータスの値を取得する
	 * @returns ステータスの値
	 */
	private getStateValue(): string {
		if (this.props.converter)
			return this.convertValue(this.props.converter, this.state.value);
		return this.state.value;
	}

	/**
	 * <br>保持判定処理
	 * @returns trueの場合、br保持
	 */
	private hasBr(): boolean {
		let content = this.state.value as string;
		if (typeof(content) === 'string' && content != null && content.includes('<br') === true && content.includes('/>') === true)
			return true;
		return false;
	}

	/**
	 * <br>付きコンテント取得
	 * @returns <br>
	 */
	private getBrContent(): any[] {
		const contentList = new Array();
		let content = this.state.value as string;
		let key = 1;
		while(content.includes('<br') === true) {
			const sidx = content.indexOf('<br');
			const eidx = content.indexOf('/>');
			contentList.push(content.substring(0, sidx));
			contentList.push(this.getBr(content.substring(sidx, eidx), key));
			content = content.substring(eidx+2);
			key++;
		}
		contentList.push(content);
		return contentList;
	}

	/**
	 * <br>取得（classNameのみ判定）
	 * @returns <br>
	 */
	private getBr(content: string, key: number): ReactNode {
		if (content.includes('className') === true) {
			const idx = content.indexOf('className');
			const str = content.substring(idx);
			const list = str.split('\'');
			return <br className={list[1]} key={key}/>;
		}
		return <br key={key}/>;
	}
	// --------------------------------------------------------------------------
}